import { getSearchParams, parseBoolean } from '@amazon/vinyl-util'

export const debug = parseBoolean(getSearchParams().get('debug'))
